import React,{ useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom'
import AdminSidebar from '../../../components/nav/AdminSidebar'
import { toast } from 'react-toastify'

import Loading from '../../../components/otros/Loading'

import { createClasificacion } from '../../../functions/api/clasificaciones';

const initialState = {
    clasificacion:'',
    activo:true
}

const CreateClasificacion = () => {

    const [loading,setLoading] = useState(false)
    const [clasificacionData,setClasificacion] = useState(initialState)

    let {user} = useSelector((state) =>({...state}))
    let navigate = useNavigate ()

    useEffect(() => {
        setLoading(true)
        setLoading(false)
    }, [])

    const {clasificacion,activo} = clasificacionData


    const handleChange = (e) =>{

        setClasificacion({...clasificacionData, [e.target.name]:e.target.value})

    }


    const submitData = (e) =>{

        e.preventDefault()
        
        createClasificacion(user.token,clasificacionData)
        .then( r => {
            toast.success('Clasificación creada exitosamente')
            setClasificacion([])
            navigate('/admin/datos-maestros/clasificaciones')
        }
        )
        .catch( err =>
                toast.error(err.response.data)
        )

    }

  return (
    <div> 
        <AdminSidebar />
        {loading ? (
          
        <div className="home">
          <Loading />
        </div>
        ):(
            <div className="home">
                <div className='navCentro'>
                <ol class="breadcrumb">
                        <li className="breadcrumb-item"><i class="fa-solid fa-screwdriver-wrench "></i> TIPOS DE TRABAJO</li>
                        <li className="breadcrumb-item">Crear clasificación</li>
                    </ol>
                    <div className="row navTab">
                        <div className="col-md-12 navTabItem">
                            <Link to='/admin/datos-maestros/clasificaciones'><i class="fa-solid fa-chevron-left mr-2"></i>Atras</Link>
                        </div>
                    </div>
                   
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <form className='formFormat1'>
                            <label>Clasificación</label>
                            <input  type='text' value={clasificacion} name='clasificacion' onChange={handleChange}></input>
                            
                            <button className='formButton1' onClick={submitData}>Crear clasificacion</button>
                        </form>
                        
                    </div>
                    </div>
            </div>
        )}
    </div>
  )
}

export default CreateClasificacion